export const SITE_CONFIG = {
  name: 'Mermaids Of The Moment',
  tagline: 'Travel Blog',
  domain: 'https://therehman.store',
  defaultDescription:
    'Join us on our adventures around the world. Discover hidden gems, beautiful destinations, and travel tips from passionate wanderers.',
  defaultImage: 'https://therehman.store/android-chrome-512x512.png',
  locale: 'en_US',
  twitter: '@mermaidsofthemoment',
  youtube: 'https://www.youtube.com/@mermaidsofthemoment',
};
